import React, { Fragment } from 'react';
import { CheckboxGroup, Checkbox } from 'react-checkbox-group';
import ReactHtmlParser from 'html-react-parser';
import $ from 'jquery';
import { desktopBreakpoint } from '../../../../constants';
import Element from '../../../../components/element';
import { each, get, includes, isArray, map } from 'lodash';
import { ReactComponent as InfoSVG } from '../../../../assets/icons/info.svg';
import ReactTooltip from 'react-tooltip';
import { colors } from '../../../../config/theme';

class CheckboxGrid extends React.Component {
  constructor(props) {
    super(props);
    this.tableRows = this.tableRows.bind(this);
    this.tableHeader = this.tableHeader.bind(this);
    this.handleGridChange = this.handleGridChange.bind(this);
    this.handleTextChange = this.handleTextChange.bind(this);
    this.mobileGrid = this.mobileGrid.bind(this);
    this.updateCSS = this.updateCSS.bind(this);

    const state = {
      text: '',
      noneOfTheAbove: false
    };
    props.yLabels.map(yLabel => (state[yLabel] = []));
    this.state = state;
  }

  updateCSS() {
    this.forceUpdate();
    if (this.props.isMobile) return;
    const contentWidth = $('.main-content').width();
    const tileWidth = contentWidth / (this.props.xLabels.length + 1) - 0.7; // add 1 for emptly left row
    $(`.checkbox-group-${this.props.index} tr th`).css({
      'min-width': `${tileWidth}px`
    });
  }

  componentDidMount() {
    const { rawAnswers, storeAnswer, index } = this.props;
    if (rawAnswers) {
      this.setState(rawAnswers);
    } else {
      // storeAnswer(index, this.state);
    }
  }

  componentWillUnmount() {
    $(window).off('resize', this.updateCSS);
  }

  handleGridChange(selected, row) {
    const { storeAnswer, questionId } = this.props;
    const obj = {};
    obj[row] = selected;
    this.setState(obj, () => {
      storeAnswer(questionId, this.state, this.isQuestionAnswered());
    });
  }

  onNoneCheckChange = e => {
    const { storeAnswer, questionId } = this.props;
    // const obj = {};
    // map(yLabels, yLabel => (obj[yLabel] = []));
    this.setState({ noneOfTheAbove: e.target.checked }, () => {
      storeAnswer(questionId, this.state, this.isQuestionAnswered());
    });
  };

  isQuestionAnswered = () => {
    const { noneOfAboveText } = this.props;
    let answered = false;
    if (noneOfAboveText && this.state.noneOfTheAbove) {
      answered = true;
    } else {
      // Logic to select all options available
      let cbListCount = 0;
      let AnsweredCBCount = 0;
      each(this.state, value => {
        if (isArray(value)) {
          cbListCount++;
          if (value.length) {
            AnsweredCBCount++;
          }
          let list = value;
          if (Array.isArray(list) && list.length > 1) {
            if (list[0] === 'N/A') {
              list.splice(0, 1);
            } else {
              const isNAExist =
                list.filter(function (val) {
                  return val === 'N/A';
                }).length > 0;
              if (isNAExist) {
                list.splice(0, list.length - 1);
              }
            }
          }
        }
        if (cbListCount > 0 && cbListCount === AnsweredCBCount) {
          answered = true;
        } else {
          answered = false;
        }
      });
    }
    return answered;
  };

  handleTextChange(e) {
    const { storeAnswer, questionId } = this.props;
    this.setState({ text: e.target.value }, () => {
      storeAnswer(questionId, this.state);
    });
  }

  tableHeader() {
    const { xLabels } = this.props;
    return xLabels.map((xLabel, index) => {
      return <th key={index}>{xLabel}</th>;
    });
  }

  mobileGrid() {
    const { xLabels, yLabels } = this.props;
    return yLabels.map((yLabel, index) => {
      return (
        <table key={index}>
          <thead>
            <tr>
              <th>{`${yLabel}:`}</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                {xLabels.map((xLabel, index) => {
                  return (
                    <CheckboxGroup
                      key={index}
                      className="survey-radio-full"
                      value={this.state[yLabel]}
                      onChange={e => this.handleGridChange(e, yLabel)}
                    >
                      <Checkbox
                        id={`${xLabel} ${yLabel}`}
                        disabled={this.props.isOldVisit}
                        className={
                          this.props.isOldVisit ? 'survey-disabled' : ''
                        }
                        value={`${xLabel}`}
                      />
                      <label
                        className={
                          this.props.isOldVisit ? 'survey-disabled' : ''
                        }
                        htmlFor={`${xLabel} ${yLabel}`}
                      >
                        {xLabel}
                      </label>
                    </CheckboxGroup>
                  );
                })}
              </td>
            </tr>
          </tbody>
        </table>
      );
    });
  }

  tableRows() {
    const { yLabels, xLabels, yToolTips } = this.props;
    return yLabels.map((rows, index) => {
      let row = xLabels.map((cell, index) => (
        <td className="survey-grid-item" key={index}>
          <CheckboxGroup
            value={this.state[rows]}
            onChange={e => this.handleGridChange(e, rows)}
          >
            <Checkbox
              id={`${cell} ${rows}`}
              disabled={this.state.noneOfTheAbove}
              className={this.props.isOldVisit ? 'survey-disabled' : ''}
              value={`${cell}`}
            />
            <label
              className={this.props.isOldVisit ? 'survey-disabled' : ''}
              htmlFor={`${cell} ${rows}`}
            />
          </CheckboxGroup>
        </td>
      ));
      return (
        <tr key={index} className="survey-radio-grid-row">
          <td className="survey-radio-grid-row-header">
            <span>{rows}</span>
            {get(yToolTips, rows) && (
              <>
                <Element
                  type="a"
                  attrs={{ 'data-tip': true, 'data-for': rows }}
                  margin="4px 0 0 4px"
                >
                  <Element type={InfoSVG} width="16px" fill="black" />
                </Element>
                <ReactTooltip
                  id={rows}
                  effect="solid"
                  place="bottom"
                  border
                  borderColor={colors.lightGray}
                  backgroundColor={colors.white}
                  textColor={colors.mineShaft}
                  className="tooltip_tip"
                >
                  <Element width="300px">{get(yToolTips, rows)}</Element>
                </ReactTooltip>
              </>
            )}
          </td>
          {row}
        </tr>
      );
    });
  }

  render() {
    const { question, questionId, className, noneOfAboveText } = this.props;
    const isMobile = window.innerWidth < desktopBreakpoint;

    return (
      <div className={`survey-checkbox-group ${className}`}>
        <Element type="p" fontFamily="GTAM" fontSize="14px">
          {ReactHtmlParser(question)}
        </Element>
        <div className="surveys-container collapse">
          <div className="surveys-list survey-checkbox-group small-12">
            {!isMobile ? (
              // this.mobileGrid()
              <table className={`checkbox-group-${this.props.index}`}>
                <tbody>
                  <tr>
                    <th />
                    {this.tableHeader()}
                  </tr>
                  {this.tableRows()}
                </tbody>
              </table>
            ) : (
              this.mobileGrid()
            )}
            {/* {!this.props.isMobile && (
              <Fragment>
                <br />
                <br />
                <br />
              </Fragment>
            )} */}

            {/* <div className="survey-label survey-item-large">
              Other (Please Specify)
            </div>
            <br />

            <input
              type="text"
              onChange={this.handleTextChange}
              value={this.state.text}
              placeholder="Type Here..."
              disabled={this.props.isOldVisit}
              className={
                this.props.isOldVisit
                  ? 'survey-disabled survey-text survey-item-large survey-force-fullwidth'
                  : 'survey-text survey-item-large survey-force-fullwidth'
              }
              style={{ minWidth: '100% !important' }}
            /> */}
            {/* {this.props.isMobile && (
              <Fragment>
                <br />
                <br />
                <br />
                <br />
              </Fragment>
            )}
            {!this.props.isMobile && (
              <Fragment>
                <br />
                <br />
                <br />
              </Fragment>
            )} */}
          </div>
        </div>
        {noneOfAboveText && (
          <Element display="flex" alignItems="center" marginTop="30px">
            <input
              type="checkbox"
              key={`${questionId}_noneOfAboveText`}
              id={`${questionId}_noneOfAboveText`}
              checked={this.state.noneOfTheAbove}
              onChange={this.onNoneCheckChange}
            />
            <Element
              type="label"
              attrs={{ htmlFor: `${questionId}_noneOfAboveText` }}
              marginBottom={0}
              marginLeft="8px"
              fontFamily="GTAM"
              fontSize="18px"
            >
              {noneOfAboveText}
            </Element>
          </Element>
        )}
      </div>
    );
  }
}

export default CheckboxGrid;
